var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"m-button",class:[_vm.cssClasses],attrs:{"type":"button","disabled":_vm.loading || _vm.disabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }